/* eslint-disable import/prefer-default-export */
import moment from 'moment';
export function getEnhancedMessages(messages) {
    return messages === null || messages === void 0 ? void 0 : messages.map((message, index, arr) => {
        var _a;
        const currentSender = message.sender.username;
        const prevSender = (_a = arr[index - 1]) === null || _a === void 0 ? void 0 : _a.sender.username;
        const nextMessage = arr[index + 1];
        const nextSender = nextMessage === null || nextMessage === void 0 ? void 0 : nextMessage.sender.username;
        const showName = currentSender !== prevSender;
        const currentDate = moment(message.createdDate);
        const nextDate = nextMessage ? moment(nextMessage.createdDate) : null;
        const isNextDayDifferent = nextDate && !currentDate.isSame(nextDate, 'day');
        const isNextSenderDifferent = currentSender !== nextSender;
        const showDate = isNextDayDifferent || isNextSenderDifferent;
        return Object.assign(Object.assign({}, message), { showName,
            showDate });
    });
}
